import { useRef, useEffect } from "react";

/**
 * Simple hook that returns the previous value
 * and stores a new value when value changes
 * @param value
 */
const usePrevious = <T,>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export default usePrevious;
